module.exports = __webpack_public_path__ + "img/onewater.8d27b7ff.png";